import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import Dettagli from "./DettagliManVen";
import axios from "axios";

function WithHeaderStyledExample() {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const [quantityOrdered2023, setQuantityOrdered2023] = useState(0);
  const [quantityOrdered2024, setQuantityOrdered2024] = useState(0);
  const [percentuale, setPercentuale] = useState("");

  const [mancataVenditaMedia, setMancataVenditaMedia] = useState({});
  const [mancataVenditaAttuale, setMancataVenditaAttuale] = useState({});
  const [percentualeValore, setPercentualeValore] = useState("");
  const [percentualeQta, setPercentualeQta] = useState("");
  const [percentualeNumCli, setPercentualeNumCli] = useState("");

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const getDateRange = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    const lastYear = currentYear - 1;
    const pad = (n) => (n < 10 ? "0" + n : n);
    const formattedMonth = pad(currentMonth);
    const formattedDay = pad(today.getDate());

    return {
      currentDateRange: `01/${formattedMonth}/${currentYear} - ${formattedDay}/${formattedMonth}/${currentYear}`,
      lastYearDateRange: `01/${formattedMonth}/${lastYear} - ${formattedDay}/${formattedMonth}/${lastYear}`
    };
  };

  const { currentDateRange, lastYearDateRange } = getDateRange();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./dati_dashboard.json");
        const { mese, mancata_vendita } = res.data.TP;

        const entry2023 = mese.find((e) => e.anno === "2025");
        const entry2024 = mese.find((e) => e.anno === "2026");
        if (entry2023) setQuantityOrdered2023(entry2023.valore_ordinato);
        if (entry2024) setQuantityOrdered2024(entry2024.valore_ordinato);

        if (entry2023 && entry2024) {
          const change = ((entry2024.valore_ordinato - entry2023.valore_ordinato) / entry2023.valore_ordinato) * 100;
          setPercentuale(change.toFixed(2));
        }

        if (mancata_vendita) {
          setMancataVenditaMedia(mancata_vendita.media);
          setMancataVenditaAttuale(mancata_vendita.attuale);
          const calcPerc = (curr, med) => med ? ((curr - med) / med * 100).toFixed(2) : "0";
          setPercentualeValore(calcPerc(mancata_vendita.attuale.valore, mancata_vendita.media.valore));
          setPercentualeQta(calcPerc(mancata_vendita.attuale.qta, mancata_vendita.media.qta));
          setPercentualeNumCli(calcPerc(mancata_vendita.attuale.num_cli, mancata_vendita.media.num_cli));
        }
        setIsLoading(false);
      } catch (error) {
        setIsError(true);
      }
    };
    fetchData();
  }, []);

  const renderTrend = (perc, inverse = false) => {
    if (perc === "") return null;
    const val = parseFloat(perc);
    const isNeg = val < 0;
    const color = inverse ? (val > 0 ? "#dc3545" : "#198754") : (isNeg ? "#dc3545" : "#198754");
    return (
      <span className="fw-bold d-flex align-items-center gap-1 text-nowrap" style={{ color: color, fontSize: "0.75rem" }}>
        {perc}% {isNeg ? <FaArrowTrendDown /> : <FaArrowTrendUp />}
      </span>
    );
  };

  return (
    <>
      <Card
        className="card ombra ordini-ora card-home hover-effect border-0"
        style={{ borderRadius: "15px", padding: "1.2rem", cursor: 'pointer' }}
        onClick={handleShowModal}
      >
        <Card.Body className="p-0"> {/* Padding rimosso qui per gestirlo nel wrapper scrollabile */}
          
          {/* WRAPPER SCROLLABILE: Si attiva sotto i 300px */}
          <div className="responsive-scroll-container">
            <div style={{ minWidth: "260px" }}> {/* Impedisce il collasso degli elementi interni */}
              
              {/* Header */}
              <div className="mb-3">
                <p className="text-title fw-bold mt-3 mb-3 text-nowrap" style={{ fontSize: "0.85rem", letterSpacing: "0.5px" }}>
                  DETTAGLI VENDITE
                </p>
                <small className="text-muted text-nowrap d-block" style={{ fontSize: "0.6rem" }}>
                  {currentDateRange} vs {lastYearDateRange}
                </small>
              </div>

              {/* Confronto Annuale */}
              <div className="d-flex flex-column gap-2 mb-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                  <span className="fw-bold text-dark small text-nowrap">TOTALE 2026</span>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-bold mb-0" style={{fontSize: '1.1rem'}}>{formatToEuro(quantityOrdered2024)}</span>
                    {renderTrend(percentuale)}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-secondary small fw-bold">TOTALE 2025</span>
                  <span className="text-secondary small fw-bold">{formatToEuro(quantityOrdered2023)}</span>
                </div>
              </div>

              {/* Sezione Mancata Vendita */}
              <div className="p-2 rounded" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}>
                <p className="text-center fw-bold mb-2 text-uppercase" style={{ fontSize: "0.65rem", color: "#495057" }}>
                  Focus Mancata Vendita
                </p>

                {/* Tabella stilizzata per allineamento perfetto */}
                {[
                  { label: "Valore", attuale: formatToEuro(mancataVenditaAttuale.valore), media: formatToEuro(mancataVenditaMedia.valore), trend: percentualeValore },
                  { label: "Clienti", attuale: mancataVenditaAttuale.num_cli, media: mancataVenditaMedia.num_cli, trend: percentualeNumCli },
                  { label: "Quantità", attuale: mancataVenditaAttuale.qta, media: mancataVenditaMedia.qta, trend: percentualeQta }
                ].map((row, i) => (
                  <div key={i} className={`d-flex justify-content-between align-items-center py-1 ${i !== 0 ? 'border-top border-white' : ''}`}>
                    <div className="d-flex flex-column" style={{ width: '33%' }}>
                      <span className="text-muted text-uppercase fw-bold x-small-font">{row.label}</span>
                      <span className="fw-bold small text-nowrap">{row.attuale}</span>
                    </div>
                    <div className="text-center d-flex flex-column" style={{ width: '33%' }}>
                      <span className="text-muted text-uppercase x-small-font">Media</span>
                      <span className="small text-dark text-nowrap">{row.media}</span>
                    </div>
                    <div className="d-flex flex-column align-items-end" style={{ width: '33%' }}>
                      <span className="text-muted text-uppercase x-small-font">Trend</span>
                      {renderTrend(row.trend, true)}
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </Card.Body>
      </Card>

      <style>{`
        .responsive-scroll-container {
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          padding: 5px;
        }
        
        /* Nasconde la scrollbar ma permette lo scroll su Chrome/Safari */
        .responsive-scroll-container::-webkit-scrollbar {
          height: 4px;
        }
        .responsive-scroll-container::-webkit-scrollbar-thumb {
          background: #e0e0e0;
          border-radius: 10px;
        }

        .x-small-font {
          font-size: 0.55rem !important;
        }

        .text-nowrap {
          white-space: nowrap;
        }

        @media (max-width: 320px) {
          .ombra.ordini-ora {
            max-width: 300px;
          }
        }
      `}</style>

      <Dettagli showModal={showModal} handleCloseModal={handleCloseModal} />
    </>
  );
}

export default WithHeaderStyledExample;